import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { TourEligibleServiceDao } from '../../../../db-models/tour-dao';
import { TravelTimeMap } from '../../../../services/tour-helpers';

@Component({
  selector: 'app-tour-time-overview',
  templateUrl: './tour-time-overview.component.html',
  styleUrls: ['./tour-time-overview.component.scss'],
  imports: [TranslateModule, FaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourTimeOverviewComponent {
  readonly selectedServices = input.required<TourEligibleServiceDao[]>();
  readonly travelMap = input.required<TravelTimeMap>();
  readonly visitMinutes = input.required<number>();
  readonly travelMinutes = input.required<number>();
  readonly totalMinutes = input.required<number>();
  readonly maxMinutes = input.required<number>();
  readonly exceedsMax = input.required<boolean>();
  readonly canBookTour = input.required<boolean>();
  readonly preparing = input<boolean>(false);
  readonly errorMessageKey = input<string | null>(null);

  readonly bookTour = output<void>();

  protected readonly progressPercent = computed(() => {
    const total = this.totalMinutes();
    const max = this.maxMinutes();
    if (!max) return 0;
    return Math.min(100, Math.round((total / max) * 100));
  });

  protected readonly maxHours = computed(() => {
    const max = this.maxMinutes();
    return Math.floor(max / 60);
  });

  protected readonly formattedTotal = computed(() => {
    const total = this.totalMinutes();
    const h = Math.floor(total / 60);
    const m = total % 60;
    return `${h}h ${m}m`;
  });

  serviceDurationMinutes(service: TourEligibleServiceDao): number {
    return Math.round((Number(service.duration) || 0) * 60);
  }

  travelToNext(index: number): number {
    const services = this.selectedServices();
    if (index >= services.length - 1) return 0;
    const key = `${services[index].id}-${services[index + 1].id}`;
    return this.travelMap().get(key) ?? 0;
  }

  onBook(): void {
    if (!this.canBookTour() || this.preparing()) return;
    this.bookTour.emit();
  }
}
